module.exports = {
	"articleTitle1": "In honor of $50 million donation, regents rename Dennison Building",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Weiser Hall",
	"articleLink1": "https://www.michigandaily.com/news/honor-50-million-donation-regents-rename-dennison-building",
	"articleLink2": "https://www.michigandaily.com/section/news/weiser-hall-basement-experiences-flooding",
	"articleSnippet1": "Dec 18, 2014 ... At their December meeting Thursday, The University's Board of Regents \napproved a motion to rename the Dennison Building “Weiser Hall” in ...",
	"articleSnippet2": "Nov 11, 2015 ... The basement of Weiser Hall, formerly known as Dennison Hall, experienced a \nsmall flood Wednesday afternoon.According to a member of the ...",
	"totalMisc": 0,
	"articleTitle2": "Weiser Hall basement experiences flooding ",
	"address": "500 Church St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/dennison%20rendered.jpg",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.276518,
		"lng": -83.735044
	},
	"tips": [
		{
			"text": "His name is Dennison",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 2,
			"bathroom": "All floors"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/weiserhall.json
// module id = 1001
// module chunks = 0